var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "generic-search-list-sidebar" },
    [
      _c("simple-list", {
        ref: "genericCode",
        staticClass: "req",
        attrs: {
          id: "genericCode",
          "server-items": _vm.items,
          query: "$and.0.category",
          "undefined-value": _vm.allLabel,
          variant: "generic-search",
          "internal-scroll": "",
          height: _vm.listHeight,
        },
        on: {
          "item-update": _vm.getFocusableElements,
          mounted: _vm.getFocusableElements,
        },
        scopedSlots: _vm._u([
          {
            key: "filter",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    ref: "genericListHeader",
                    staticClass: "generic-list-header",
                  },
                  [
                    _c("generic-list-search-bar", {
                      on: { "filter-items": _vm.filterItems },
                    }),
                    _vm._v(" "),
                    _c("generic-list-categories", {
                      attrs: { categories: _vm.categories },
                      on: { "filter-items": _vm.filterItems },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "rendered-list",
            fn: function (ref) {
              var filteredItems = ref.items
              return [
                _c(
                  "ul",
                  _vm._l(filteredItems, function (item) {
                    return _c(
                      "li",
                      { key: item.id },
                      [
                        _c("generic-list-card", {
                          attrs: {
                            item: item,
                            "search-input": _vm.inputString,
                            "query-changed": _vm.queryChanged,
                            "is-loading": _vm.isLoading,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("loading-dots"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }